export class EmailContent{
    public emailid: string;
    public mobile: string;
    public message:string;
    public name:string;

}